import React from 'react'
import block from 'bem-cn-lite'
import BlinkingMarker from '../../Components/BlinkingMarker'
import { I18n } from 'react-i18next'

class ReportStatuses extends React.Component {

    render() {
        const b = block('ReportStatuses')

        const { statuses } = this.props

        var markStatus = null;

        switch(this.props.step) {
            case 'deselectOne':
            case 'deselectOneMore':
                markStatus = statuses.find(status => this.props.inactiveStatuses.indexOf(status.id) === -1);
                break;

            case 'selectOne':
            case 'selectOneMore':
                markStatus = statuses.find(status => this.props.inactiveStatuses.indexOf(status.id) > -1);
                break;
            default:
                break;
            
        }


        return (
            <I18n>
            {
                (t) => (
                    <div className={b()}>
                        <h4 className={b('title')}>{t('report:status')}</h4>

                        <div className={b('content')}>
                            <ul className={b('list')}>
                                {statuses.map((status, index) => 
                                    <li className={b('item', { inactive: this.props.inactiveStatuses.indexOf(status.id) > -1})}
                                        key={status.id} 
                                        onClick={ e => this.props.onStatusClick(status.id) }
                                    >
                                        {(markStatus && markStatus.id === status.id) &&
                                            <BlinkingMarker left={-22} top={2} />
                                        }
                                        <span 
                                            className={b('item-color')}
                                            style={ {backgroundColor: `rgb(${status.color})`, borderColor: `rgb(${status.color})` } }>
                                        </span>
                                        <span className={b('item-label')}>{status.name}</span>
                                    </li>
                                )}

                            </ul>

                        </div>
                    </div>
                )
            }
            </I18n>
            
        )
    }
}

export default ReportStatuses;